type TelemetryActionRecorder = (name: string, context?: object) => boolean

let recorder: TelemetryActionRecorder | undefined
const beforeViewChange = new Set<() => void>()

export function setTelemetryActionRecorder(next: TelemetryActionRecorder | undefined): void {
  recorder = next
}

/** Returns undefined until RUM is initialized; otherwise records in the current view synchronously. */
export function recordTelemetryAction(name: string, context?: object): boolean | undefined {
  return recorder?.(name, context)
}

export function subscribeBeforeRumViewChange(callback: () => void): () => void {
  beforeViewChange.add(callback)
  return () => {
    beforeViewChange.delete(callback)
  }
}

export function notifyBeforeRumViewChange(): void {
  for (const callback of beforeViewChange) callback()
}
